import X from "@/nav-localized/assets/footer/social/x.svg?react";
import Discord from "@/nav-localized/assets/footer/social/discord.svg?react";
import Email from "@/nav-localized/assets/footer/social/email.svg?react";
import Telegram from "@/nav-localized/assets/footer/social/telegram.svg?react";
import Instagram from "@/nav-localized/assets/footer/social/instagram.svg?react";
import Youtube from "@/nav-localized/assets/footer/social/youtube.svg?react";
import Vk from "@/nav-localized/assets/footer/social/vk.svg?react";
import { useStoreState } from "../../../../packages/Footer/store/useStore";
import {
  IconStyle,
  LabelColor,
  PopoverBgStyles,
  PopoverHoverStyle
} from "../../../../packages/Footer/styles";
import { Popover } from "@blofin/blofin-ui";
import { useTranslations } from "use-intl";

const reflectLang: any = {
  "zh-tw": "-tw",
  "ko-kr": "-kr"
};

const Community = () => {
  const { theme, locale } = useStoreState();

  const t = useTranslations("footer");

  const isRu = locale === "ru";
  const telegramHref = isRu ? "https://t.me/blofincischat" : "https://t.me/BloFin_Official";
  const youtubeHref = isRu
    ? "https://www.youtube.com/@BlofinCIS"
    : "https://www.youtube.com/@BloFin_Official";

  return (
    <div className="w-full max-w-screen-xl px-0">
      <div className="flex gap-[16px] mt-[40px]">
        <a href="https://x.com/Blofin_Official" target="_blank" rel="noreferrer">
          <X className={IconStyle({ theme })} />
        </a>
        <a href={telegramHref} target="_blank" rel="noreferrer">
          <Telegram className={IconStyle({ theme })} />
        </a>
        <a href="https://www.instagram.com/blofinofficial/" target="_blank" rel="noreferrer">
          <Instagram className={IconStyle({ theme })} />
        </a>
        <a href="https://discord.gg/sn3uu2BByU" target="_blank" rel="noreferrer">
          <Discord className={IconStyle({ theme })} />
        </a>
        <a href={youtubeHref} target="_blank" rel="noreferrer">
          <Youtube className={IconStyle({ theme })} />
        </a>
        {isRu && (
          <a href="https://vk.com/blofincis" target="_blank" rel="noreferrer">
            <Vk className={IconStyle({ theme })} />
          </a>
        )}
        <Popover
          placement="top"
          x={80}
          label={<Email className={IconStyle({ theme })} />}
          content={
            <div
              className={`py-[16px] w-[220px] flex flex-col gap-2 rounded ${PopoverBgStyles({ theme })}`}
            >
              <a
                className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                href="mailto:support@blofin.com"
              >
                <span className="mx-[16px] text-sm">{t("supportService")}</span>
              </a>

              <a
                className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                href="mailto:listing@blofin.com"
              >
                <span className="mx-[16px] text-sm">{t("listing")}</span>
              </a>

              <a
                className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                href={`mailto:bd${reflectLang[locale] || ""}@blofin.com`}
              >
                <span className="mx-[16px] text-sm">{t("businessOpportunity")}</span>
              </a>
              <a
                className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                href={`mailto:legalrequest@blofin.com`}
              >
                <span className="mx-[16px] text-sm">{t("lawEnforcementRequests")}</span>
              </a>
              <a
                className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                href={`mailto:audit@blofin.com`}
              >
                <span className="mx-[16px] text-sm">{t("audit")}</span>
              </a>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default Community;
